<template>
  <v-row>
    <v-col>
      <v-card>
        <v-card-title>
          <span class="headline">Batch watcher</span>
        </v-card-title>
        <v-card-text v-if="batch === null">
          Fetching batch data...
        </v-card-text>
        <v-card-text v-else>
          <v-progress-linear
            :value="percentageComplete"
            :color="percentageComplete < 100 ? 'blue-grey' : 'green'"
            height="25"

          >
            <strong v-if="percentageComplete < 100">{{this.batch.processedJobs}} of {{this.batch.totalJobs}} complete</strong>
            <strong v-else>Batch complete</strong>
          </v-progress-linear>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: ['batchID'],

  data() {
    return {
      batch: null,
    }
  },

  created() {
    this.updateBatch();
    this.startWatch();
  },

  computed: {
    percentageComplete() {
      if (this.batch === null) {
        return 0;
      }

      return this.batch.processedJobs / this.batch.totalJobs * 100;
    },
  },

  methods: {
    updateBatch() {
      axios.get(`/api/developer/batchprogress/${this.batchID}`)
        .then(response => {
          this.batch = response.data.batch;
        });
    },

    startWatch() {
      const watcher = setInterval(() => {
        if (this.percentageComplete < 100) {
          this.updateBatch();
        } else {
          clearInterval(watcher);
          return
        }
      }, 10000);
    }
  }
};
</script>
